import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { IDefinitionState } from '@interfaces/definition.interface';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'definitions', resettable: true })
export class DefinitionsStore extends Store<IDefinitionState> {
  constructor() {
    super({
      unitConfigs: [],
      activeUnitConfigs: [],
    });
  }
}
